$(document).ready(function(){
    $(document).on('click', '.createExchange', function(e){
        e.preventDefault();

        var id = $(this).data('id');
        var customer = $(this).data('customer');
        var postcode = $(this).data('postcode');
        var address_id = $(this).data('address_id');
        var url = $(this).data('url');
        user_id = customer;

        $.post(url, {'partial' : 'createExchangeCustomer', 'address_id' : address_id, 'job_id' : id}, function(data){
            var html = data.html;

            var box = bootbox.confirm({
                title: "Confirm",
                message: html,
                onShown: function(e) {

                    $('.datepicker-future').datepicker('destroy');
                    $('.datepicker-future').datepicker({
                        format: 'yyyy-mm-dd',
                        startDate: "today",
                        date: new Date(),
                    });
                },
                callback: function (result) {
                    if(result)
                    {
                        var error = false;
                        var service = $('#services').val();
                        var delivery_date = $('.delivery_date').val();
                        var card_id = $('input[name="card_id"]:checked').val();
                        var cost = $('input[name=cost]').val();
                        //var payment_type = 'Stripe';
                        var payment_type = $('.paymentTypeOnExchange:checked').val();

                        var time = $("input[name=time_option]:checked").val();
                        var end = '';

                        if(time == '8')
                        {
                            time = '08:00:00';
                            end = '12:00:00';

                        }else{
                            time = '12:00:00';
                            end = '17:00:00';
                        }

                        var full_date = delivery_date + ' ' + time;
                        var full_end_date = delivery_date + ' ' + end;

                        var unixTimestamp = moment(full_date, "YYYY-MM-DD hh:mm:ss").unix();
                        var unixTimestampEnd = moment(full_end_date, "YYYY-MM-DD hh:mm:ss").unix();
                        unixTimestamp = unixTimestamp * 1000;
                        unixTimestampEnd = unixTimestampEnd * 1000;


                        console.log(unixTimestamp);
                        console.log(unixTimestampEnd);
                        console.log(service);
                        if(service == '') {

                            $('select#services').closest('.form-group').find('.invalid-feedback').html('<strong>This field is required</strong>');
                            error = true;
                        }

                        console.log(payment_type);
                        if(payment_type == 'Stripe')
                        {
                            if(typeof card_id === 'undefined')
                            {
                                $('#payment_type').closest('.form-group').find('.invalid-feedback').html('<strong>This field is required</strong>');
                                error = true;
                            }
                        }

                        if(error)
                        {
                            return false;
                        }

                        loader.classList.remove('fadeOut');
                        $('.modal').modal('hide');
                        $.post(globals.route.exchangeSkip, {'payment_type' : payment_type,
                            'delivery_date' : delivery_date,
                            'unixTimestamp' : unixTimestamp,
                            'unixTimestampEnd' : unixTimestampEnd,
                            'card_id' : card_id,
                            'job_id' : id,
                            'cost' : cost,
                            'user_id' : user_id,
                            'service' : service}, function(data){
                            loader.classList.add('fadeOut');

                            bootbox.alert({'message' : data.resp.description});
                            window.LaravelDataTables["dataTableBuilder"].ajax.reload();
                        }, 'json');

                        $('.bootbox-accept').attr('disabled', 'disabled');
                        $('.bootbox-accept').prop('disabled', 'disabled');

                        return false;
                    }
                }
            });

            box.on('shown.bs.modal', function(e){
                $('#payment_type').data('user', user_id);
                $.fn.paymentInit();
                $('input[name=customer_user_id]').val(user_id);
                $('input[name=postcode]').val(postcode);
                // if(showAddCardContainer)
                // {
                //     $('.showAddCardContainer').fadeIn();
                // }
                console.log(user_id);
                const json = $.fn.getStripeData(user_id, false).then(function(res) {

                    var showAddCardContainer = false;
                    console.log(res);

                    if(res.code == '1' || res.code == '2')
                    {
                        showAddCardContainer = true;
                    }
                    var template = $('.showAddCardContainerTemplate').clone();
                    template.prepend(res.html);
                    var html = '<div class="cards-list-container">' +  template.html() + '</div>';
                    //
                    // var box = bootbox.confirm({
                    //     title: "Confirm",
                    //     message: html,
                    //     callback: function (result) {
                    //         if(result)
                    //         {
                    //             if(box.find('input[name="card_id"]:checked').length == 0)
                    //             {
                    //                 box.find('input[name="card_id"]').addClass('is-invalid');
                    //                 console.log('1');
                    //                 return false;
                    //             }
                    //
                    //             box.find('input[name="card_id"]').removeClass('is-invalid');
                    //
                    //
                    //             var card_id = box.find('input[name="card_id"]:checked').val();
                    //
                    //             var fn = '$.fn.chargeCustomer("' + card_id + '", ' + id + ')';
                    //             $.fn.loginToComfirm($('.bootbox-accept'), '', fn);
                    //             return false;
                    //         }
                    //     }
                    // });

                    // box.on('shown.bs.modal', function(e){
                    //     $.fn.paymentInit();
                    //     if(showAddCardContainer)
                    //     {
                    //         $('.showAddCardContainer').fadeIn();
                    //     }
                    // });
                });

                $('.datepicker-future').datepicker({
                    format: 'yyyy-mm-dd',
                    startDate: "today",
                    date: new Date(),
                });


            });
        }, 'json');
    });

    $(document).on('click', '.paymentTypeOnExchange', function(e){
        var value = $('.paymentTypeOnExchange:checked').val();

        if(value == '0')
        {
            $('.cards-main-container').fadeIn();
        }else{
            $('.cards-main-container').fadeOut();
        }

        order.payment_type = value;
    });

    // collection request

    $(document).on('click', '.requestCollection', function(e){
        e.preventDefault();

        var id = $(this).data('id');
        var customer = $(this).data('customer');
        var url = $(this).data('url');
        user_id = customer;

        $.post(url, {'partial' : 'requestCollection', 'job_id' : id}, function(data){
            var html = data.html;

            var box = bootbox.confirm({
                title: "Confirm",
                message: html,
                onShown: function(e) {
                    $('.datepicker-future').datepicker('destroy');
                    var min = $('.datepicker-future').data('min');

                    console.log(min);
                    if(typeof min === 'undefined')
                    {
                        min = new Date();
                    }else{
                        var from = min.split("-");
                        min = new Date(from[0], from[1] - 1, from[2]);
                    }

                    console.log(min);
                    $('.datepicker-future').datepicker({
                        format: 'yyyy-mm-dd',
                        startDate: min,
                        date: min,
                    });
                },
                callback: function (result) {
                    if(result)
                    {
                        var error = false;
                        var delivery_date = $('.delivery_date').val();
                        var time = $("input[name=time_option]:checked").val();
                        var end = '';

                        if(time == '8')
                        {
                            time = '08:00:00';
                            end = '12:00:00';

                        }else{
                            time = '12:00:00';
                            end = '17:00:00';
                        }

                        var full_date = delivery_date + ' ' + time;
                        var full_end_date = delivery_date + ' ' + end;

                        var unixTimestamp = moment(full_date, "YYYY-MM-DD hh:mm:ss").unix();
                        var unixTimestampEnd = moment(full_end_date, "YYYY-MM-DD hh:mm:ss").unix();
                        unixTimestamp = unixTimestamp * 1000;
                        unixTimestampEnd = unixTimestampEnd * 1000;

                        loader.classList.remove('fadeOut');
                        $('.modal').modal('hide');
                        $.post(globals.route.requestCollection, {
                            'delivery_date' : delivery_date,
                            'unixTimestamp' : unixTimestamp,
                            'unixTimestampEnd' : unixTimestampEnd,
                            'job_id' : id,
                            'user_id' : user_id}, function(data){
                            loader.classList.add('fadeOut');

                            bootbox.alert({'message' : data.description});
                            window.LaravelDataTables["dataTableBuilder"].ajax.reload();
                        }, 'json');

                        $('.bootbox-accept').attr('disabled', 'disabled');
                        $('.bootbox-accept').prop('disabled', 'disabled');

                        return false;
                    }
                }
            });

            box.on('shown.bs.modal', function(e){
                $('#payment_type').data('user', user_id);
                $('input[name=customer_user_id]').val(user_id);

                $('.datepicker-future').datepicker({
                    format: 'yyyy-mm-dd',
                    startDate: "today",
                    date: new Date(),
                });

            });
        }, 'json');
    });


    // collection request


    $(document).on('change', '.exchange-container .services', function(e){
        var rate = $(this).find('option:selected').data('rate');
        $('input[name="cost"]').val(rate);
    });

    $(document).on('click', '.generateInvoice', function(){
        $.fn.waitingDialog().show('Please wait while we retrieve the data');

        var job_id = $(this).data('id');
        $.post(globals.route.jobs_invoice, {'job_id': job_id}, function(data){
            $.fn.waitingDialog().hide();
            window.open(data.url, 'blank');
        }, 'json');
    });
});



// WEBPACK FOOTER //
// ./resources/js/app/my_orders/index.js